// import { firebase, googleAuthProvider } from '../firebase/firebase';
import axios from 'axios';
import { history }  from '../routers/AppRouter'
import { clearActiveEvent } from './event'
import getAppConfigParm  from '../config/AppConfig';
import { updateParticipants } from './participants';
import { updateContacts } from './contacts';
import { updateItemList } from './items';
import { clearPicAppError, updateEventListFilter } from './picapp';
// import { flushItemListUpdates } from './items';
import dpbutils from '../utils/dpbutils';
import PicPutRequest from '../apis/PicPutRequest'

//************************************************************************ */
// Configuration
//************************************************************************ */

// Obtain filename and initialize appname for logging purpose
const filename = 'auth.js';
const appname  = 'pic';

//************************************************************************ */
// Action / Action Creators
//************************************************************************ */

export const captureMessage = (message = '') => ({
    type:  'CAPTURE_MESSAGE',
    message
});

// This action, when routed to reducer, will effectively set all required fields
// as if user logged in successfully. 
export const signUp = (signUpData = {}) => ({
    type:  'SIGNUP',
    isAuthenticated: true,
    user:  signUpData.user,
    token: signUpData.token
});

// Currently this action is triggered when encountering a login error
export const authError = (error) => ({
    type: 'AUTH_ERROR',
    error
});

// Currently this action is triggered when encountering a login error
export const clearAuthError = (error) => ({
    type: 'CLEAR_AUTH_ERROR',
    error: ''
});


// This is used as first step of the login process, It sets loginInProgress to true. 
// to let redux and any listeners know that login is in progress.
// The action is called from inside startLogin async action
export const initiateLogin = () => ({
    type: 'INITIATE_LOGIN',
    loginInProgress: true
})


// This is is third step of the login process. Update redux store login status
// The action is called from inside startLogin async action
export const login = (loginData = {}) => ({
    type: 'LOGIN',
    isAuthenticated: true,
    user:  loginData.user,
    token: loginData.token
})

// This is last  step of the login process, It sets loginInProgress flag to false
// to let redux and any listeners know that login is in progress is completed.
// The action is called from inside startLogin async action
export const finalizeLogin = () => ({
    type: 'FINALIZE_LOGIN',
    loginInProgress: false     /* used for spinner in loginForm */
})

// This step does  the  actual login into database and calls the various actions:
// initiate login - this updates redux  loginInProgress flag to true
// login - this updates redux with isAuthenticated to true, user, token, and loginInProgress flag to false
// finalize login is called if login fails. This action will et loginInProgress to false
export const startLogin = (formData = {}) => {
    return (dispatch, getState ) => {

        // Clear current error, if one already exist
        if (getState().auth.error) {dispatch(clearAuthError())};

        // initialize error message information
        let errmsg = '';
        let functionName = 'startLogin';
        let uri = 'POST /users/login';
        
        // Construct url and request header
        let loginUrl   = getAppConfigParm("authUrl") + '/users/login'; 
        let axiosConfig = getAppConfigParm("axiosConfig"); 

        // Set loginInProgress flag to let component know you are initiating login and disable Login button
        dispatch(initiateLogin());

        // This resets the logoutInProgress flag which needs to remain in place to restrict componentWillUnmount
        // api calls to fire during logout prorcess, otherwise they will fail once logout has delete token.
        dispatch(logoutInProgress(false)); 
        

        // Make api call to verify user id. If user id / password are valid,
        // api will return user id, firstname, email and token in the header.
        
        console.log("Start Login Call ", new Date())
        axios.post(loginUrl, formData, axiosConfig)
         .then(function (response) {
            let id = response.data._id;
            let firstname = response.data.firstname;
            let lastname =  response.data.lastname;
            let email = response.data.email;
            let token = response.headers["x-auth"];
            dispatch(login({ user: {id, firstname, lastname, email}, token}));
            dispatch(finalizeLogin());  /* let component know login is completed */
            dispatch(updateEventListFilter("All My Events"));
            console.log("Completed Login Call ", new Date())
            history.push('/dashboard');
        }).catch ((error) => {
            dispatch(finalizeLogin());  /* let component know login is done even though it failed */
            if (error.response) {   /* server responded with status code out of 2xx range(success) */
                let errorResponseMsg = error.response.data.errmsg;
                if (errorResponseMsg.indexOf('Invalid password') !== -1) {      /* logged on server side */
                    dispatch(authError("Invalid password"));
                } else if (errorResponseMsg.indexOf('NoRecordFound') !== -1) {  /* logged on server side */
                    dispatch(authError("Email not found. Use email you signed up with"));
                } else {
                    errmsg = `No Response(1) after calling startLogin Action API by user ${formData.email}`; 
                    dispatch(authError("Server maintenance, try again later"));
                }
            } else if (error.request) { /* request made but no response received */
                dispatch(authError("Server not responding, please try again later"));
                errmsg = `No Response(2) after calling startLogin Action API by user ${formData.email}`; 
            } else { /* something happened setting up request that triggered error */
                if (error.message.indexOf('Network Error') !== -1 ) {
                    var error = error.message;
                    errmsg = `Network issue occurred making axios call to '${uri}' from function ${functionName} by email:'${formData.email}'`
                    dispatch(authError("Server not responding,  try again later"));
                } else {
                    console.log(`NO RESPONSE from startLogAction API call`);
                    errmsg = `Uncaught exception occurred making axios call to '${uri}' from function ${functionName} by email:'${formData.email}'`;
                    dispatch(authError("Server not responding - try again later"));
                }
            }
            // Save exception (errmsg) in datatabase
            errmsg && dpbutils.saveErrorRecord(appname, filename, functionName, formData.email, errmsg, error);
        });
    }
};


// This is called via the "Forgot password?" link, at the bottom of the Login form.
// This link will provide simple form for user to enter email address. When they submit
// form,  user's email will be used to generate an email that has a link (along with id 
// and token), for user to reset password. When user clicks the link, they will be routed 
// to form where they can enter new password (ResetPwPage).
export const sendResetPwMail = (email = {}) => {
    return (dispatch, getState ) => {

        // initialize error message information
        let errmsg = '';
        let functionName = 'sendResetPwMail';
        let uri = 'POST /passwordreset';

        // Clear current error, if one already exist
        if (getState().auth.error) {dispatch(clearAuthError())};

        // Construct url for api call set content type to text/plain on header  
        let url   = getAppConfigParm("authUrl") + '/passwordreset'; 
        let axiosConfig = getAppConfigParm("axiosConfig"); 

        // Make api call to send user an email to reset their password
        axios.post(url,  email, axiosConfig)
         .then(function (response) {
            dispatch(captureMessage(`Email was sent to ${email.email}`))
            history.push('/forgotpw2'); /* send user back to home page */
        }).catch ((error) => {
            console.log('email.email', email.email);
            if (error.response) {   /* server responded with status code out of 2xx range(success) */
                let errorResponseMsg = error.response.data.errmsg;
                if (errorResponseMsg.indexOf('Does Not Exist') !== -1) {
                    dispatch(authError("Cannot find account registered with this email"));
                } else if (errorResponseMsg.indexOf('Missing email') !== -1) {
                    dispatch(authError("Please provide email"));    
                } else {
                    dispatch(authError("Server busy, please try again later"));
                }
            } else if (error.request) { /* request made but no response received */
                errmsg = `Did not get response back from uri:${uri} called from function:${functionName}; this was fired from the resetPwd form, for email:${email.email}`;
                dispatch(authError("Server busy, please try again later"));
            } else { /* something happened setting up request that triggered error */
                if (error.message.indexOf('Network Error') !== -1 ) {
                    // Concat error components
                    errmsg = `NetworkError: making axios api call to uri:${uri} from function:${functionName} from email:'${email.email}'`
                    dispatch(authError("Server busy, please try again later"));
                } else {
                    errmsg = `UncaughtException: when user submitted following email:${email.email} in the forgot password form`;
                    dispatch(authError("Server busy - please try again later"));
                }
            }
        });
        // Log/save any error message from catch block
        errmsg && dpbutils.saveErrorRecord(appname, filename, functionName, email.email, errmsg, error);
    }
};


// Use googleAuthProvider that was exported from firebase.js
// export const startLogin = () => {
//     return () => {
//         return firebase.auth().signInWithPopup(googleAuthProvider);
//     };
// };

// This action, when routed to reducer, will set isAuthenticated flag to false
// and clear the user id, firstname, and email fields on redux store.
export const logout = () => {
    return {
        type: 'LOGOUT'
    }
}

// Start logout kicks off the process for logging off the application.
// Step1: startLogout - dispatches event to let componentWillUnmount methods
//        know that logout is in progress. Otherwise, logout may delete 
//        token beforehand causing any authentication required api calls 
//        to fail. API calls from componentWillUnmount should not fire
//        if logoff is in progress. If you need to do cleanup, do it in 
//        startLogout. 
// Step2: flush out any data in cache that has not been
//        persisted.
// Step3: Dispatch  event to delete user Token and clearout redux
// Step4: Dispatch message to set logoutInProgess to false. 
export const startLogout = () => {
    // THIS ACTION IS DESIGNED TO TAKE ANY LAST MINUTE ACTIONS BEFORE LOGOFF LIKE EXTERNALIZING DATA
    return (dispatch, getState ) => {
      /* dispatch "logout in progress" event so that api calls that require token dont fire from
         componentWillUnmount lifecycle methods */
      /* IMPORTANT: This should NOT be reset until login; If reset at end of logout, it may occur before 
        componentWillUnmount fires, and cause api calls (from componentWillUnmount) to fail */
      dispatch(logoutInProgress(true));  

    /* SECTION BELOW IS USED TO EXTERNALIZE any data in redux store you have not persisted to DB. */

    /*  If there is no active event,  just dispatch event to delete token and clear redux and exit */
    // if (!getState().event.active) {
    //     dispatch(deleteTokenAndClearRedux())
    //     return;
    // }

    /* If we are here it means we have an active event; I will externalize todos (helping hands)
       and todos*/

    /* Obtain required api parameters */
    // let userid = getState().auth.user.email;
    // let token = getState().auth.token;
    // let event_id = getState().event.active._id; 

    /* construct api body to update contributions list */
    // let items = getState().items.list; 

    // let reqBody = {
    //     event_id,
    //     items
    // }

    /* Call api to externalize contributions from redux store  */
    // let putRequest = new PicPutRequest("UpdateContributionsList");
    // putRequest.setUserId(userid)
    //     .setUri("/event/contributions")
    //     .setAuthToken(token)
    //     .setRequestBody(reqBody)
    //     .setLogTrace(true);
    // putRequest.exec()
    //     .then( (response) => {
    //         trace && prtMsg("This is response from UpdateContributionsList API");
    //         trace && console.log(response);
    //         /* construct api body for todos list */
    //         let todos = getState().todos.list;
    //         let reqBody = {
    //             event_id,
    //             todos
    //         }
    //         /* construct api body to update helping hands list (todos) */
    //         let putRequest = new PicPutRequest("UpdateHelpingHandsList");
    //         putRequest.setUserId(userid)
    //             .setUri("/event/todos")
    //             .setAuthToken(token)
    //             .setRequestBody(reqBody)
    //             .setLogTrace(true);
    //         putRequest.exec()
    //     }).then( (response) => {
    //                 trace && prtMsg("This is response from UpdateHelpingHandsList");
    //                 trace && console.log(response);
            dispatch(deleteTokenAndClearRedux())
    //     }).catch((error) => {
    //         trace && prtMsg("This is error encountered from UpdateContributionsList API call");
    //         trace && console.log(error);
    //         dispatch(deleteTokenAndClearRedux())
    //     });
    } /* end of outter return statement */
} /* end of the startLogout action*/


// This is part of Step1 outlined above
export const logoutInProgress = (status) => {
    return {
        type: 'LOGOUT_IN_PROGRESS',
        logoutInProgress: status
    }
}

// start action returns a function that takes care of pre-requisite tasks
// before updating redux store. In this case, we want to set authorization 
// token to false; then we dispatch a traditional LOGOUT event to remove 
// token and user object from redux store. Because redux store is sync'ed 
// with local storage, it will also be removed from local storage. 
// the logout reducer will clear all fields including auth.error.
export const deleteTokenAndClearRedux = () => {
    return (dispatch, getState ) => {

        // initialize error message information
        let errmsg = '';
        let functionName = 'deleteTokenAndClearRedux';
        let uri = 'delete /users/me/token';
        let email = getState().auth.user.email; 
        let systemErrorText = "no system message";
        
        let token = getState().auth.token;
        console.log("This token at logout ", token)
        // Construct url for api call and set up header
        let url    = getAppConfigParm("authUrl") + '/users/me/token'; 
        let header = getAppConfigParm("axiosConfig", token);
        console.log('url', url);
        console.log('header', header);
        // Make api call to delete token from database
        axios.delete(url, header)
         .then(function (response) {
            dispatch(logout());
            dispatch(clearActiveEvent());
            dispatch(updateParticipants([])); /* passing in empty array has same effect as clear participants*/
            dispatch(updateContacts([])); /* passing in empty array has same effect as clear contacts */
            dispatch(updateItemList([])); /* passing in empty array has same effect as clear items */
            dispatch(clearPicAppError()); /* passing in empty array has same effect as clear items */
            dispatch(updateEventListFilter(''));
            history.push('/'); /* send user back to home page */
        }).catch ((error) => {  /* TBD - this error should be logged to database */
            localStorage.removeItem('state'); /* clean out state if user not able log off */
            errmsg = `Error encountered in function:${functionName} calling uri:${uri} for user ${email} `;
            dpbutils.saveErrorRecord(appname, filename, functionName, email, errmsg, error);
        });
    }
};


// This action, when routed to reducer, will effectively set all required fields
// as if user logged in successfully. 
export const resetPw = (resetPwData = {}) => ({
        type: 'RESET_PASSWORD',
        isAuthenticated: true,
        user:  resetPwData.user,
        token: resetPwData.token
});

// This gets called when user enters password new password and confirmation password on form.
// The formData parameter passed in below consists of id and 1x token that was submitted via url.
// The API call for reset password, will base it off the user id. If user id is valid,
// api will verify token. If both are successfully validated, the password will be changed
// and new token will be generated and returned in the header along with a json response.
// The json response will have the user details: id, email,  firstname and lastname.
export const startResetPw = (formData) => {
    return (dispatch, getState ) => {

        // initialize error message information
        let errmsg = '';
        let functionName = 'startResetPw';
        let uri = 'POST /resetpassword';
        
        // Clear current error, if one already exist
        if (getState().auth.error) {dispatch(clearAuthError())};

        // Construct url and request header
        let url   = getAppConfigParm("authUrl") + `/resetpassword/`; 
        let header = getAppConfigParm("axiosConfig"); 

        // Make api call
        axios.post(url, formData, header)
         .then(function (response) {
            let firstname = response.data.firstname;
            let email = response.data.email;
            let id = response.data._id;
            let token = response.headers["x-auth"];
            let user = {id, email, firstname};
            dispatch(resetPw({user, token}));
            history.push('/dashboard');
        }).catch ((error) => {
            if (error.response) {   /* server responded with status code out of 2xx range(success) */
                let errorResponseMsg = error.response.data.errmsg;
                if (errorResponseMsg.indexOf('Token passed is Invalid') !== -1) {
                    dispatch(authError("Email Link Invalid: Please look for latest email sent and try again"));
                } else if (errorResponseMsg.indexOf('User id not found') !== -1) {
                    dispatch(authError("User id not found"));
                } else {
                    dispatch(authError("Email Link Invalid: Please look for latest email sent and try again"));
                }
            } else if (error.request) { /* request made but no response received */
                errmsg = `Seems there was no response from form used to provide new password via uri:${uri} from function:${functionName}`;
                dispatch(authError("Server busy, please try again later"));
            } else { /* something happened setting up request that triggered error */
                if (error.message.indexOf('Network Error') !== -1 ) {
                    errmsg = `NetworkError: from form used to reset password via uri:${uri} from function:${functionName}`
                    dispatch(authError("Server not responding,  try again later"));
                } else {
                    errmsg = `UncaughtException: from form used to reset password via uri:${uri} from function:${functionName}`;
                    dispatch(authError("Server busy - please try again later"));
                }
            }
            errmsg && dpbutils.saveErrorRecord(appname, filename, functionName, formData.id, errmsg, error); 
        });
    }
};

// Use googleAuthProvider that was exported from firebase.js
// export const startLogout = () => {
//     return () => {
//         return firebase.auth().signOut();
//     };
// };


// WEBPACK FOOTER //
// ./src/actions/auth.js